import React, { useEffect, useState } from 'react';
import { Container } from './styles';
import { Table } from '@gerdau/hefesto-mais-web';
import { CustomTableCell } from '../../../../../components/Commons/Tables/styles';
import {
  ILastOrder,
  ILastOrderItem
} from '../../../../../store/ducks/long-steel-order-item-search/types';
import { useDispatch } from 'react-redux';
import { searchItemsFromLastOrder } from '../../../../../store/ducks/long-steel-order-item-search/actions';
import moment from 'moment';

interface LastOrderListProps {
  items: ILastOrder[];
  customerState: string;
}

export interface ILastOrderTableDataSource {
  key: number;
  invoiceNumber: string;
  invoiceSale: string;
  quantityProduct: number;
  invoiceDate: string;
  items: ILastOrderItem[];
}

const columns = [
  {
    title: 'Número do pedido',
    dataIndex: 'invoiceNumber',
    width: '9rem',
    sorter: (a: ILastOrderTableDataSource, b: ILastOrderTableDataSource) =>
      Number(a.invoiceNumber) - Number(b.invoiceNumber),
    render: (invoiceNumber: string) => (
      <CustomTableCell>{invoiceNumber}</CustomTableCell>
    )
  },
  {
    title: 'Ordem de venda',
    dataIndex: 'invoiceSale',
    width: '6rem',
    sorter: (a: ILastOrderTableDataSource, b: ILastOrderTableDataSource) =>
      Number(a.invoiceSale) - Number(b.invoiceSale),
    render: (invoiceSale: string) => (
      <CustomTableCell>{invoiceSale}</CustomTableCell>
    )
  },
  {
    title: 'Quantidade de produtos',
    dataIndex: 'quantityProduct',
    width: '7rem',
    sorter: (a: ILastOrderTableDataSource, b: ILastOrderTableDataSource) =>
      Number(a.quantityProduct) - Number(b.quantityProduct),
    render: (quantityProduct: string) => (
      <CustomTableCell>{quantityProduct}</CustomTableCell>
    )
  },
  {
    title: 'Data do pedido',
    dataIndex: 'invoiceDate',
    width: '7rem',
    sorter: (a: ILastOrderTableDataSource, b: ILastOrderTableDataSource) =>
      moment(a.invoiceDate, 'YYYY-MM-DD').toDate().getTime() -
      moment(b.invoiceDate, 'YYYY-MM-DD').toDate().getTime(),
    render: (invoiceDate: string) => (
      <CustomTableCell>{invoiceDate}</CustomTableCell>
    )
  }
];

const LastOrderList: React.FC<LastOrderListProps> = ({
  items,
  customerState
}) => {
  const dispatch = useDispatch();

  const [lastOrdersItems, setLastOrdersItems] = useState<
    ILastOrderTableDataSource[]
  >([]);

  useEffect(() => {
    const lastOrdersItemsData: ILastOrderTableDataSource[] = items.map(
      (item: ILastOrder, index: number) => ({
        key: index,
        invoiceNumber: item.customerPurchaseOrder,
        invoiceSale: item.salesOrder,
        invoiceDate: moment(item.orderDate).format('DD/MM/YYYY'),
        quantityProduct: item.items.length,
        items: item.items
      })
    );

    lastOrdersItemsData.sort((lastOrderItem1, lastOrderItem2) =>
      lastOrderItem1.invoiceDate > lastOrderItem2.invoiceDate
        ? -1
        : lastOrderItem1.invoiceDate > lastOrderItem2.invoiceDate
        ? 1
        : 0
    );

    setLastOrdersItems(lastOrdersItemsData);
  }, [items]);

  return (
    <Container>
      <Table
        columns={columns}
        dataSource={lastOrdersItems}
        rowSelection={{
          type: 'radio',
          onChange: (
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            _: any,
            selectedRows: ILastOrderTableDataSource[]
          ) => {
            const [selectedRow] = selectedRows;
            const lastOrder = items.find(
              (_: ILastOrder, index: number) => selectedRow.key === index
            );
            if (lastOrder) {
              dispatch(searchItemsFromLastOrder(lastOrder, customerState));
            }
          }
        }}
      ></Table>
    </Container>
  );
};
export default LastOrderList;
